import React from 'react';
import Notification from "./Notification";
import PropTypes from "prop-types";
import RequestedNotification from "./RequestedNotification";

const NotificationsList = props => {
  return (
      <table
          className="table table-bordered table-striped table-hover text-center main-table notifications-table">
        <tbody>
        {props.notifications.map(notification => (
            <Notification notification={notification} key={notification.id} auth={props.auth}
                          markAsSeen={props.markAsSeen}/>))}
        {props.requestToChange.map(notification => (
            <RequestedNotification key={notification.id} notification={notification} acceptOrReject={props.acceptOrReject}/>))}
        </tbody>
      </table>
  );
};

NotificationsList.propTypes = {
  notifications: PropTypes.array,
  auth: PropTypes.object.isRequired,
  markAsSeen: PropTypes.func.isRequired,
  requestToChange: PropTypes.array,
  acceptOrReject: PropTypes.func.isRequired
};

export default NotificationsList;



// WEBPACK FOOTER //
// ./src/components/NotificationsList/NotificationsList.jsx